<div class="page-header-container">
    <div class="page-title">
        {{'log.title' | translate}}
    </div>
</div>

<div class="header-buttons-box">
    <div class="custom-text-input-container search-container flex-grow-1">
        <i class="app-icon icon icon-search icon-xl"></i>
        <kendo-textbox
            type="text"
            [clearButton]='true'
            [placeholder]="'log.searchPlaceholder' | translate"
            (valueChange)="searchQuery$.next($event)">
        </kendo-textbox>
    </div>

    
    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
        {{'adminUsers.filter' | translate}}
    </button>
    
    <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
        <div class="btn-group" role="group">
            <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                <span>{{'adminUsers.filterActive' | translate}}</span>
            </button>
            <button class="btn white-btn" (click)="resetFiltersHandler()">
                <span class="active-filters-badge">{{activeFilterCount}}</span>
                <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
            </button>
        </div>
    </div>
</div>


<log-list-view [logs]="logs" [props] = "props"></log-list-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>